import { PROJECT__SET, PROJECT__SET_NAME } from "@/store/mutation-types";
import ProjectModel from "@/models/lab/ProjectModel";

const getStored = (key) => {
  let val = localStorage.getItem(key);
  if (val && val !== "") {
    return val;
  }
  return null;
};

const assignModel = (state, key, model) => {
  if (!model || !model.id) {
    model = null;
  }
  state[key] = model;
  if (model) {
    localStorage.setItem(key, JSON.stringify(model._attributes));
  } else {
    localStorage.removeItem(key);
  }
};

const state = {
  project__current: getStored("project__current")
    ? new ProjectModel(JSON.parse(getStored("project__current")))
    : null,
  project__name: getStored("project__name") ? getStored("project__name") : null,
};

const getters = {
  getCurrentProject: (state) => state.project__current,
  getCurrentProjectName: (state) => state.project__name,
};

const mutations = {
  PROJECT__SET(state, project) {
    assignModel(state, "project__current", project);
  },
  PROJECT__SET_NAME(state, project) {
    state["project__name"] = project.publicNumber();
    localStorage.setItem("project__name", state["project__name"]);
  },
};

const actions = {
  PROJECT__SET_CURRENT: ({ commit }, { project }) => {
    commit(PROJECT__SET_NAME, project);
    return commit(PROJECT__SET, project);
  },
  async PROJECT__FETCH_CURRENT({ commit }, { project_id }) {
    let project = new ProjectModel({ id: project_id });
    return project.fetch().then(() => {
      commit(PROJECT__SET_NAME, project);
      commit(PROJECT__SET, project);
      return project;
    });
  },
};

export default {
  getters,
  mutations,
  actions,
  state,
};
